import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PhoneIcon, MenuIcon, XIcon, ShieldCheckIcon } from 'lucide-react';
import { SITE } from '../constants/site';
const NAV = [{
  label: 'Services',
  href: '#services'
}, {
  label: 'Why Us',
  href: '#why'
}, {
  label: 'Service Area',
  href: '#area'
}, {
  label: 'Reviews',
  href: '#reviews'
}, {
  label: 'FAQ',
  href: '#faq'
}];
import { AlertCircleIcon } from 'lucide-react';
export function Header({
  onOpenSchedule
}: {
  onOpenSchedule?: () => void;
}) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-50 w-full transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur shadow-md' : 'bg-white/80 backdrop-blur'}`} data-id="element-145" data-mp="3b81wy3didk79">
      <div className="bg-slate-900 px-4 py-2 text-xs font-bold tracking-wide text-white sm:text-sm" data-id="element-146" data-mp="2wlm91fajw6kf">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 sm:flex-row sm:gap-4" data-id="element-147" data-mp="2rkyl52hmc5uf">
          <span className="inline-flex items-center gap-2" data-id="element-148" data-mp="2mmx1afcdc2hw">
            <span className="relative flex h-2 w-2" data-id="element-149" data-mp="2hodekcpyamoh">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-nfgreen opacity-75" data-id="element-150" data-mp="2hpojwgz1o2hp"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-nfgreen" data-id="element-151" data-mp="3acizazh08bob"></span>
            </span>
            24/7 Emergency Service & Same-Day Appointments
          </span>
          <a href={SITE.phoneHref} className="inline-flex items-center gap-1.5 text-nfgreen-light transition-colors hover:text-white" data-id="element-152" data-mp="35j6c8trz4cxo">
            <PhoneIcon className="h-3.5 w-3.5" data-id="element-153" data-mp="1wpi0ieumw67" />
            Call Now: {SITE.phone}
          </a>
        </div>
      </div>
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8" data-id="element-154" data-mp="3tabrp7u0537g">
        <a href="#top" className="flex items-center gap-2 sm:gap-3" aria-label={SITE.shortName} data-id="element-155" data-mp="1rew8aj4c8tro">
          <img src={SITE.logoUrl} alt={`${SITE.shortName} logo`} className="h-12 w-auto sm:h-16" data-id="element-156" data-mp="1wbcw1c7ml648" />
          <div className="flex flex-col" data-id="element-157" data-mp="1hmyporb02zix">
            <span className="font-display text-base font-extrabold leading-none text-slate-900 sm:text-lg" data-id="element-158" data-mp="1mmuyd3un7f4t">
              Northface
            </span>
            <span className="text-[9px] font-bold uppercase tracking-widest text-nfblue sm:text-[11px]" data-id="element-159" data-mp="18mafk7oq9jbb">
              Irrigation
            </span>
          </div>
        </a>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary" data-id="element-160" data-mp="ypp7telbpu3s">
          {NAV.map(item => <a key={item.href} href={item.href} className="text-sm font-semibold text-slate-700 transition-colors hover:text-nfblue" data-id="element-161" data-mp="13n77sfhd4yzn">
              {item.label}
            </a>)}
        </nav>

        <div className="hidden items-center gap-3 lg:flex" data-id="element-162" data-mp="2y2jlbv7wce5m">
          <span className="flex items-center gap-1.5 text-xs font-semibold text-nfgreen-dark" data-id="element-163" data-mp="2xzxc7r5cxqla">
            <ShieldCheckIcon className="h-4 w-4" data-id="element-164" data-mp="mck4qv3l6upd" />
            Licensed & Insured
          </span>
          <button onClick={onOpenSchedule} className="inline-flex items-center gap-2 rounded-full bg-nfblue px-5 py-2.5 text-sm font-bold text-white shadow-sm transition-transform hover:scale-[1.03] hover:bg-nfblue-dark" data-id="element-165" data-mp="hdgxr541qeer">
            Schedule Visit
          </button>
        </div>

        <button className="inline-flex h-10 w-10 items-center justify-center rounded-lg text-slate-700 lg:hidden" onClick={() => setOpen(v => !v)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-166" data-mp="153l25ep26i6t">
          {open ? <XIcon className="h-6 w-6" data-id="element-167" data-mp="1f0zh19vc2yx0" /> : <MenuIcon className="h-6 w-6" data-id="element-168" data-mp="1a3pjt81pdiym" />}
        </button>
      </div>

      <AnimatePresence data-id="element-169" data-mp="1a2eh7bjzuh93">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="overflow-hidden border-t border-slate-100 bg-white lg:hidden" data-id="element-170" data-mp="3gu6x4lirtkjy">
            <nav className="flex flex-col px-4 py-4" aria-label="Mobile" data-id="element-171" data-mp="27wp2i1fgqkn4">
              {NAV.map(item => <a key={item.href} href={item.href} onClick={() => setOpen(false)} className="rounded-lg px-3 py-3 text-base font-semibold text-slate-700 hover:bg-slate-50" data-id="element-172" data-mp="2cxwde9cwjzy0">
                  {item.label}
                </a>)}
              <div className="mt-4 flex flex-col gap-3 border-t border-slate-100 pt-4" data-id="element-173" data-mp="1k9qpjdqjxuty">
                <a href={SITE.phoneHref} className="flex items-center justify-center gap-2 rounded-lg bg-slate-50 px-5 py-3 text-base font-bold text-slate-800" data-id="element-174" data-mp="1p81zdoguk5c6">
                  <PhoneIcon className="h-5 w-5 text-nfgreen-dark" data-id="element-175" data-mp="1y03ztmqx1lmg" />
                  Call: {SITE.phone}
                </a>
                <button onClick={() => {
              setOpen(false);
              onOpenSchedule?.();
            }} className="inline-flex items-center justify-center gap-2 rounded-full bg-nfblue px-5 py-3 text-base font-bold text-white" data-id="element-176" data-mp="11gmym04pxw31">
                  Schedule Visit
                </button>
              </div>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}